<div class="grid grid-cols-12">
  <div class="col-span-12">
    <div class="aspect-w-2 aspect-h-1">
      <div
        class="absolute inset-0 bg-center bg-no-repeat bg-cover flex items-center justify-center"
      >
        <div class="container max-w-2xl mx-auto">
          <div class="grid grid-cols-12">
            <div class="col-span-12">
              <div class="text-center">
                <h1 class="mb-3">Not Found</h1>

                <p class="mb-5">
                  Sorry, we couldn't find the page you were looking for
                </p>

                <app-button route="/" expand="block" size="large">
                  Take me home
                </app-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
